import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Selector, SelectorOption } from '@fashionnovateam/nova-ui-toolkit';
import { HelpCenterBreadcrumbs } from '../Navigation/HelpCenterBreadcrumbs';
import { HomeViewProps } from '../types';

export function HomeView({ helpCenterData, onContactClick }: HomeViewProps) {
  const { userId } = useParams<{ userId: string }>();
  const history = useHistory();

  const handleSectionChange = (values: string[]) => {
    const selectedValue = values[values.length - 1];
    if (selectedValue) {
      const selectedSection = helpCenterData?.sections?.find(
        (s) => s.title === selectedValue,
      );
      if (selectedSection) {
        history.push(
          `/users/${userId}/help-center/${selectedSection.title.toLowerCase()}`,
        );
      }
    }
  };

  if (!helpCenterData || !helpCenterData.sections) {
    return null;
  }

  return (
    <div className="max-w-[800px] px-4 sm:px-2 md:px-0">
      <HelpCenterBreadcrumbs helpCenterData={helpCenterData} />
      <h1 className="text-2xl md:text-4xl font-medium mb-1 md:mb-2">
        {helpCenterData.helpCenterTitle}
      </h1>
      <p className="text-base md:text-lg nu-text-base-disabled mb-4 md:mb-8">
        {helpCenterData.helpCenterDescription}
      </p>

      <p className="text-xs md:text-xsm font-medium mb-1 md:mb-2">
        Quick Links
      </p>
      <div className="flex flex-col space-y-1 md:space-y-2 mb-4 md:mb-8">
        <button
          type="button"
          onClick={onContactClick}
          className="text-left text-xs md:text-sm font-medium nu-text-primary-700 hover:underline"
        >
          Contact Us
        </button>
      </div>

      <p className="text-xs md:text-xsm font-medium mb-2 md:mb-3">Sections</p>
      <Selector
        onChange={handleSectionChange}
        className="flex flex-col gap-1 -m-2"
      >
        {helpCenterData.sections.map((section) => (
          <SelectorOption
            key={section.title}
            value={section.title}
            label={section.title}
            name={section.title.toLowerCase()}
            noMargin
          >
            <div className="flex items-center p-3 md:p-6 justify-between w-full">
              <div>
                <h2 className="text-sm md:text-md font-medium">
                  {section.title}
                </h2>
                <p className="text-xs md:text-sm nu-text-base-disabled">
                  {section.description}
                </p>
              </div>
              <img
                src={section?.icon?.viewUrl || ''}
                alt={section.title}
                className="w-8 h-8 md:w-12 md:h-12"
              />
            </div>
          </SelectorOption>
        ))}
      </Selector>
    </div>
  );
}
